export default {
  // 设置 cookie
  setCookie(value, days, name) {
    name = name || 'topenid';
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value};expires=${expires}`;
  },
  // 设置 cookie
  setCookie2(value, seconds, name) {
    name = name || 'topenid';
    const d = new Date();
    d.setTime(d.getTime() + seconds * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value};expires=${expires}`;
  },
  // 根据type 取cookie
  getCookie(name) {
    name = name || 'topenid';
    const v = window.document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`); // 正则匹配cookie字段
    return v ? v[2] : null;
  },
  // 从url获取相关参数
  getQueryString(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    const r = window.location.search.substr(1).match(reg);
    if (r !== null) {
      return unescape(r[2]);
    }
    return null;
  },
};
